export default "__VITE_ASSET__hp8bTahz__"